import { setupGoogleAnalytics, setupPtEngine } from '..';

export function startAnalyticsRuntime() {
  setupGoogleAnalytics();
  setupPtEngine();

  return () => {};
}
